import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import Header from "./components/header";
import Main from "./components/main";
import Footer from "./components/footer";
import ChatMeSDK from "./components/ChatMeScript";
import ScrollToTopButton from "../../components/ScrollToTopButton";

const TermsAndConditions = () => {

  return (
        <div className="flex flex-col w-full min-h-screen">
      <Header />
            <div className="bg-[#031602] flex-1 pt-20">
                <div className="container mx-auto px-4 py-8 text-white">
                    <div className="rounded-lg">
                        <h1 className="text-4xl font-medium mb-10 text-center bg-gradient-to-b from-white to-[#50B553] bg-clip-text text-transparent relative pb-4">
                            <FormattedMessage id="LANDINGPAGE.FOOTER.TERMS_AND_CONDITION" />
                        </h1>

                        {/* Introduction */}
                        <div className="mb-8">
                            <p className="text-white leading-relaxed text-base font-light text-justify">
                                <FormattedMessage id="LANDINGPAGE.TERMS.INTRODUCTION" />
                            </p>
                        </div>

                        {/* Section 1 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.TITLE" />
                            </h2>
                            <p className="text-white text-base font-light text-justify">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.DESC" />
                            </p>

                            <div className="ml-4">
                                <h3 className="text-base font-medium text-white">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.TITLE" />
                                </h3>
                                <ul className=" text-white text-base font-light">
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE1" /></li>
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE2" /></li>
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE3" /></li>
                                    <ul className="ml-6 space-y-1 text-base font-light">
                                        <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE3.1" /></li>
                                        <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE3.2" /></li>
                                        <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE3.3" /></li>
                                        <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE3.4" /></li>
                                        <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.1.RULE3.5" /></li>
                                    </ul>
                                </ul>
                            </div>

                            <div className="ml-4">
                                <h3 className="text-base font-medium text-white">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.2.TITLE" />
                                </h3>
                                <ul className=" text-white text-base font-light">
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.2.RULE1" /></li>
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.2.RULE2" /></li>
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION1.2.RULE3" /></li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 2 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION2.TITLE" />
                            </h2>
                            <p className="text-white text-base font-light text-justify">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION2.DESC" />
                            </p>
                            <ul className=" text-white ml-4 text-base font-light">
                                <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION2.RULE1" /></li>
                                <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION2.RULE2" /></li>
                                <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION2.RULE3" /></li>
                                <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION2.RULE4" /></li>
                            </ul>
                        </div>

                        {/* Section 3 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION3.TITLE" />
                            </h2>
                            <p className="text-white leading-relaxed text-base font-light text-justify">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION3.DESC" />
                            </p>
                        </div>

                        {/* Section 4 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION4.TITLE" />
                            </h2>
                            <p className="text-white text-base font-light text-justify">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION4.DESC" />
                            </p>
                            <ul className=" text-white ml-4 text-base font-light">
                                <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION4.RULE1" /></li>
                                <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION4.RULE2" /></li>
                                <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION4.RULE3" /></li>
                            </ul>
                            <p className="text-white mt-4 text-base font-light text-justify">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION4.NOTE" />
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION5.TITLE" />
                            </h2>
                            <p className="text-white leading-relaxed text-base font-light text-justify">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION5.DESC" />
                            </p>
                        </div>

                        {/* Section 6 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION6.TITLE" />
                            </h2>

                            <div className="ml-4">
                                <h3 className="text-base font-medium text-white">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION6.1.TITLE" />
                                </h3>
                                <p className="text-white text-base font-light">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION6.1.DESC" />
                                </p>
                            </div>

                            <div className="ml-4">
                                <h3 className="text-base font-medium text-white">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION6.2.TITLE" />
                                </h3>
                                <p className="text-white text-base font-light">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION6.2.DESC" />
                                </p>
                            </div>

                            <div className="ml-4">
                                <h3 className="text-base font-medium text-white">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION6.3.TITLE" />
                                </h3>
                                <p className="text-white text-base font-light">
                                    <FormattedMessage id="LANDINGPAGE.TERMS.SECTION6.3.DESC" />
                                </p>
                            </div>
                        </div>

                        {/* Section 7 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION7.TITLE" />
                            </h2>
                            <p className="text-white leading-relaxed text-base font-light">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION7.DESC" />
                            </p>
                        </div>

                        {/* Section 8 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION8.TITLE" />
                            </h2>
                            <p className="text-white leading-relaxed text-base font-light">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION8.DESC" />
                            </p>
                        </div>

                        {/* Section 9 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION9.TITLE" />
                            </h2>
                            <p className="text-white leading-relaxed text-base font-light">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION9.DESC" />
                            </p>
                        </div>

                        {/* Section 10 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION10.TITLE" />
                            </h2>
                            <p className="text-white leading-relaxed text-base font-light">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION10.DESC" />
                            </p>
                        </div>

                        {/* Section 11 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION11.TITLE" />
                            </h2>
                            <div className=" text-white">
                                <p className="text-base font-light"><FormattedMessage id="LANDINGPAGE.TERMS.SECTION11.DESC1" /></p>
                                <p className="text-base font-light"><FormattedMessage id="LANDINGPAGE.TERMS.SECTION11.DESC2" /></p>
                                <p className="text-base font-light"><FormattedMessage id="LANDINGPAGE.TERMS.SECTION11.DESC3" /></p>
                                <ul className="ml-6 text-base font-light">
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION11.DESC3.1" /></li>
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION11.DESC3.2" /></li>
                                    <li><FormattedMessage id="LANDINGPAGE.TERMS.SECTION11.DESC3.3" /></li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 12 */}
                        <div className="mb-8">
                            <h2 className="text-base font-semibold text-white">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION12.TITLE" />
                            </h2>
                            <p className="text-white leading-relaxed text-base font-light">
                                <FormattedMessage id="LANDINGPAGE.TERMS.SECTION12.DESC" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
      <Footer />
      <ScrollToTopButton />
            <ChatMeSDK />
    </div>
  );
};

export default TermsAndConditions;
